import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'highlightText',
    standalone: false
})
export class HighlightTextPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, searchTerm: string, className: string): SafeHtml {
    if (!value || !searchTerm) {
      return value;
    }

    const terms = searchTerm
      .split(' ')
      .map(term => term.trim())
      .filter(term => term.length > 0)
      .map(term => term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));

    if (terms.length === 0) return value;

    const regex = new RegExp(terms.join('|'), 'gi');

    const parts = value.split(/(<img[^>]*>)/gi); // will get the image tags as well and wants to remove to avoid the image

    const highlightedText = parts.map(part => {
      if (part.match(/<img[^>]*>/gi)) {
        return part; 
      }
      return part.replace(regex, match => `<mark class="${className}">${match}</mark>`);
    }).join('');

    return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
  }
}